module.exports = "/_next/static/images/macpunks-og-b60064c599bd5c37fca063cf15e70827.jpg";